const e = [
  "green300",
  "green100",
  "red200",
  "red100",
  "gold100",
  "gold200",
  "black100",
  "white"
], n = {
  COLOR_CODES: e
};
export {
  e as COLOR_CODES,
  n as default
};
//# sourceMappingURL=top-banner-info-constants.js.map
